import {
  CATEGORY_FACETS_MAP,
  HIDDEN_FACETS,
  CATEGORY_COLORS,
} from '~~/layers/legacy-search/app/settings'
import type { SearchFacetTerm } from '~~/layers/legacy-search/app/types'
import { getQueryParamArray } from '~/helpers'

export interface QueryParams {
  page?: string
  sort_by?: string
  f?: string[]
}

/**
 * Filter out query parameters that are dependent on other parameters.
 */
export function filterRouteQuery(originalQuery: Record<string, unknown>): any {
  const query = { ...originalQuery } as Record<string, unknown>

  // Delete params not relevant for the map view.
  if (query.map) {
    delete query.sort_by
    delete query.page
    delete query.location
  }

  // Delete params only visible for specific categories.
  if (query.f) {
    const terms = (Array.isArray(query.f) ? query.f : [query.f]).filter(Boolean)

    const category = query.category as string
    if (category) {
      const allowedFacets = CATEGORY_FACETS_MAP[category] || []

      query.f = terms.filter((v) => {
        const facet = v.split(':')[0]
        const isHidden = HIDDEN_FACETS.includes(facet)
        const allowedIncludes = allowedFacets.includes(facet)

        return !isHidden || allowedIncludes
      })
    } else {
      query.f = terms.filter((v) => {
        const facet = v.split(':')[0]
        return !HIDDEN_FACETS.includes(facet)
      })
    }
  }

  return query
}

export function getTermLink(
  routeQuery: Record<string, any>,
  facetId: string,
  term: SearchFacetTerm,
) {
  const id = facetId + ':' + term.key

  const query = { ...routeQuery }
  delete query.page
  const facetItems = getQueryParamArray(query, 'f')
  let f = [...facetItems]

  if (term.active) {
    f = f.filter((v) => v !== id)
  } else {
    f.push(id)
  }

  query.f = f

  return {
    query,
  }
}

export function getFilterCategoryColor(id: string) {
  return CATEGORY_COLORS[id] || ''
}

export function getFilterCategoryColorStyle(
  id: string,
): Record<string, string> {
  const color = CATEGORY_COLORS[id] || ''
  if (!color) {
    return {}
  }

  return {
    color: `rgb(var(--color-${color}) / 1)`,
  }
}
